module.exports = __webpack_public_path__ + "img/sld_four_transformer_dark.856f65d8.svg";